import type {ChatData, ChatMessage} from 'chats'

export const sortMessagesByDate = (first: ChatMessage, second: ChatMessage) =>
  first.date - second.date

export const sortByLastActive = (left: ChatData, right: ChatData) => {
  const dateA = left.createdAt ?? 0
  const dateB = right.createdAt ?? 0

  let comparison = 0
  if (dateA > dateB) {
    comparison = -1
  } else if (dateA < dateB) {
    comparison = 1
  }
  return comparison
}
export const sortByLastMessage = (left: ChatData, right: ChatData) => {
  const dateA = left.lastMessage?.date ?? 0
  const dateB = right.lastMessage?.date ?? 0

  let comparison = 0
  if (dateA > dateB) {
    comparison = -1
  } else if (dateA < dateB) {
    comparison = 1
  }
  return comparison
}
